import { Solicitudes } from './solicitudes';
export class ResultadoBusquedaSolicitudes {

  subconjuntoSolicitudes: Solicitudes[];
  totalSolicitudes: number;

  constructor() { }

  static toModel(json: string): ResultadoBusquedaSolicitudes {
    const data = JSON.parse(json);
    const toReturn = new ResultadoBusquedaSolicitudes();

    if (data.Servicios) {
      toReturn.subconjuntoSolicitudes = data.Servicios.map((solicitud: Solicitudes) => Solicitudes.toModel(JSON.stringify(solicitud)));
    }
    toReturn.totalSolicitudes = data.ContadorServicios;
    return toReturn;
  }

}
